import React from "react";
import {
  CameraOutlined,
  RootCrossOutlined,
  CodeOutlined,
  DeviceDesktopOutlined,
  GoogleDriveColored,
  OneDriveColored,
  MicrophoneOutlined,
  AttachmentClipOutlined,
} from "@toddle-edu/ds-icons";

export const OPTIONS = {
  ADD_AUDIO: "ADD_AUDIO",
  DIVIDER: "DIVIDER",
  ADD_IMAGE_FROM_CAMERA: "ADD_IMAGE_FROM_CAMERA",
  ADD_ATTACHMENT_FROM_DEVICE: "ADD_ATTACHMENT_FROM_DEVICE",
  ADD_MATH_EQUATION: "ADD_MATH_EQUATION",
  CODE_EDITOR: "CODE_EDITOR",
  ADD_GRAPH: "ADD_GRAPH",
  TODDLE_DOC: "TODDLE_DOC",
  WORKBOOK: "WORKBOOK",
};

export const CHAT_OPTIONS = [
  {
    key: OPTIONS.ADD_AUDIO,
    icon: <MicrophoneOutlined variant={"subtle"} />,
    hasDivider: true,
    tooltipText: "common:record_message",
  },
  {
    key: OPTIONS.ADD_IMAGE_FROM_CAMERA,
    icon: <CameraOutlined variant={"subtle"} />,
    tooltipText: "common:take_photo",
  },
  {
    key: OPTIONS.ADD_ATTACHMENT_FROM_DEVICE,
    icon: <AttachmentClipOutlined variant={"subtle"} />,
    tooltipText: "common:attach_images",
  },
  {
    key: OPTIONS.ADD_MATH_EQUATION,
    icon: <RootCrossOutlined variant={"subtle"} />,
    tooltipText: "equationEditor:equation_editor_heading",
  },
  {
    key: OPTIONS.CODE_EDITOR,
    icon: <CodeOutlined variant={"subtle"} />,
    tooltipText: "ai:code_editor",
  },
  // {
  //   key: OPTIONS.ADD_GRAPH,
  //   icon: <AnalyticsOutlined variant={"subtle"} />,
  //   tooltipText: "worksheet:graphing_tool",
  // },
];

export const SCROLL_THRESHOLD = 8;
export const SCROLL_STEP = 240;

export const graphConfig = {
  showEditGraphOption: true,
  showGraphDropdown: true,
  showSaveButton: true,
  allowAlgebraView: true,
};

export const ATTACHMENT_PICK_KEYS = [
  "id",
  "name",
  "type",
  "mimeType",
  "url",
  "thumbUrl",
  "title",
  "metadata",
  "streamUrl",
  "parentType",
  "createdBy",
];

export const DIALOGS_INFO = {
  CLEAR_CHAT: {
    title: ({ t }) => t("classRoom:clear_chat"),
    message: ({ t }) => t("classRoom:clear_chat_history_msg"),
    buttonOneText: ({ t }) => t("common:cancel"),
    buttonTwoText: ({ t }) => t("common:clear"),
  },
  CLEAR_CHAT_AND_GENERATE: {
    title: ({ t }) => t("ai:clear_chat_with_question_mark"),
    message: ({ t }) => t("ai:selecting_a_new_prompt_warning_msg"),
    buttonOneText: ({ t }) => t("ai:go_back_to_library"),
    buttonTwoText: ({ t }) => t("ai:clear_chat_and_generate"),
  },
};

export const LOADER_STATES = {
  DEFAULT: "DEFAULT",
  FULL_SCREEN: "FULL_SCREEN",
  CREATING_CHATBOT: "CREATING_CHATBOT",
  UPDATING_CHATBOT: "UPDATING_CHATBOT",
  CREATING_SAMPLE_CONVERSATION: "CREATING_SAMPLE_CONVERSATION",
  INTERACTING_WITH_THE_TUTOR: "INTERACTING_WITH_THE_TUTOR",
};

export const ALLOWED_FILE_TYPES = [
  "image/jpeg", // .jpeg
  "image/jpg", // .jpg
  "image/png", // .png
  "image/gif", // .gif,
  "image/webp", // .webp
];

export const CREATE_DROPDOWN_OPTIONS = [
  {
    key: "upload_device",
    label: "common:upload_device",
    icon: <DeviceDesktopOutlined size={"xx-small"} />,
  },
  {
    key: "add_google_drive",
    label: "common:add_google_drive",
    icon: <GoogleDriveColored size={"xx-small"} />,
  },
  {
    key: "add_one_drive",
    label: "common:add_one_drive",
    icon: <OneDriveColored size={"xx-small"} />,
  },
];

export const AI_TUTOR_TTS_MODEL = "toddle-tts-v6";
